import MustacheComponent from '@components/mustache-component';

class PaginatorComponent extends MustacheComponent
{
    constructor($template)
    {
        super($template);
        this.data = {
            nbPages: 0
        }
    }

    prepare()
    {
        let loop = [];
        for (var i = this.data.firstPageToDisplay; i < this.data.lastPageToDisplay + 1; i++) {
            loop.push({
                value: i,
                active: i == this.data.currentPage
            })
        }

        let data = {
            loop: loop,
            first: this.data.currentPage > 1 ? this.data.currentPage - 1 : false,
            last: this.data.currentPage < this.data.lastPageToDisplay ? this.data.currentPage + 1 : false,
            data: this.data
        }

        return data;
    }

    render()
    {
        if (!this.data.nbPages) {
            return '';
        }
        return super.render();
    }
}

export default PaginatorComponent;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/components/paginator-component.js